import { type ContactFormValues } from './ContactFormValues'

export const directContactFormMakeDefaultValues = (): ContactFormValues => ({
  email: '',
  fcSolution: '',
  firstName: '',
  images: [],
  lastName: '',
  message: '',
  orderId: '',
  phoneNumber: '',
  productCode: '',
  subject: '',
})
